/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonInviteInfo,
    JsonInviteInfoFromJSON,
    JsonInviteInfoFromJSONTyped,
    JsonInviteInfoToJSON,
} from './JsonInviteInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonInviteInfo
 */
export interface ApiResultOfJsonInviteInfo {
    /**
     * 
     * @type {JsonInviteInfo}
     * @memberof ApiResultOfJsonInviteInfo
     */
    data?: JsonInviteInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonInviteInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteInfo
     */
    result?: ApiResultOfJsonInviteInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonInviteInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonInviteInfoFromJSON(json: any): ApiResultOfJsonInviteInfo {
    return ApiResultOfJsonInviteInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonInviteInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonInviteInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonInviteInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonInviteInfoToJSON(value?: ApiResultOfJsonInviteInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonInviteInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

